import { authService } from '../../../service/auth-service'
import { EventBusActionType, EventBusEntityType, eventBusUtil } from '../../../util/event-bus-util'
import { logger } from '../../../util/logger'
import { ErrorMessageHint } from '../../util/error-message-hint'
import { InputCode } from '../../util/input-code'
import { OverlaySpinner } from '../../util/spinner/overlay-spinner'
import style from './create.module.scss'
import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import * as yup from 'yup'

const verifyAccountEmailSchema = yup
  .object()
  .shape({
    emailVerificationCode: yup
      .string()
      .test('len', 'Email verification code must be exactly 6 characters', (val) => (val ?? '').length === 6)
      .required('Email verification code is required.'),
  })
  .required()

export const VerifyAccountEmailStep = (props: { email?: string }): React.ReactElement => {
  const { email } = props
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState<string>()
  const [emailVerificationCode, setEmailVerificationCode] = useState('')
  const [codeInvalid, setCodeInvalid] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (e: any): Promise<void> => {
    e.preventDefault()
    try {
      if (setIsLoading) setIsLoading(true)
      setErrorMessage(undefined)
      const isValid = await verifyAccountEmailSchema.isValid({ emailVerificationCode })
      setCodeInvalid(!isValid)
      if (!isValid || !email) return // TODO throw some error if email is null or handle on component init
      await authService.registerVerifyEmail({ email, code: emailVerificationCode })
      eventBusUtil().emit({
        action: EventBusActionType.CREATE,
        entity: EventBusEntityType.EMAIL_VERIFIED,
        meta: { email },
      })
      history.push(`/create-account/reset-password`)
    } catch (err) {
      logger.error(err)
      setErrorMessage(err.message)
    } finally {
      if (setIsLoading) setIsLoading(false)
    }
  }

  const handleResendEmail = async (): Promise<void> => {
    try {
      if (setIsLoading) setIsLoading(true)
      if (!email) return // TODO throw some error if email is null or handle on component init
      await authService.registerNewUser({ email })
    } catch (err) {
      logger.error(err)
    } finally {
      if (setIsLoading) setIsLoading(false)
    }
  }

  return (
    <>
      <Form onSubmit={onSubmit}>
        <h1 className="text-center">Verify email address</h1>
        <Form.Group className={style.inputContainerGroup}>
          <InputCode onValueChanged={setEmailVerificationCode} isInvalid={codeInvalid} />
          <p className="text-center mt-5">
            Please enter the 6-digit code on the email sent to <strong>{email}</strong>
          </p>
          <div className="text-center">
            <Button className="btn btn-link" onClick={handleResendEmail}>
              Resend Email
            </Button>
          </div>
          <ErrorMessageHint message={errorMessage} />
        </Form.Group>
        <Form.Group className="form-group">
          <Button type="submit" className="w-100" disabled={emailVerificationCode.length !== 6}>
            Continue
          </Button>
        </Form.Group>
      </Form>
      {isLoading && <OverlaySpinner />}
    </>
  )
}
